import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCustomer } from '../services/customers';
import { customerKeys } from './useCustomersQuery';
import type { NewCustomerFormInputs } from '../schemas/customer.schemas';
import type { Customer } from '../types/customers.types';

export const useCreateCustomerMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (customerData: NewCustomerFormInputs): Promise<Customer> => {
            return createCustomer(customerData);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: customerKeys.all });
        },
        onError: (error: Error) => {
            console.error('Failed to create customer:', error);
        },
    });
};
